"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultSigner = void 0;
const protocol_crypto_1 = require("@moojo/protocol-crypto");
const stable_stringify_1 = require("../utils/stable-stringify");
class DefaultSigner {
    signingKey;
    constructor(signingKey) {
        this.signingKey = signingKey;
    }
    sign(signable) {
        const { signature: _ignore, ...singable } = signable;
        const hash = (0, protocol_crypto_1.computeHash)((0, stable_stringify_1.stableStringify)(singable));
        const signature = this.signingKey.signDigest(hash).toString('base64');
        return { ...signable, signature };
    }
}
exports.DefaultSigner = DefaultSigner;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdC1zaWduZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2lnbi9kZWZhdWx0LXNpZ25lci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw0REFBZ0U7QUFFaEUsZ0VBQTJEO0FBRzNELE1BQWEsYUFBYTtJQUNLO0lBQTdCLFlBQTZCLFVBQXNCO1FBQXRCLGVBQVUsR0FBVixVQUFVLENBQVk7SUFBRyxDQUFDO0lBRXZELElBQUksQ0FBcUIsUUFBVztRQUNsQyxNQUFNLEVBQUUsU0FBUyxFQUFFLE9BQU8sRUFBRSxHQUFHLFFBQVEsRUFBRSxHQUFHLFFBQVEsQ0FBQTtRQUNwRCxNQUFNLElBQUksR0FBRyxJQUFBLDZCQUFXLEVBQUMsSUFBQSxrQ0FBZSxFQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUE7UUFDbkQsTUFBTSxTQUFTLEdBQUcsSUFBSSxDQUFDLFVBQVUsQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxDQUFBO1FBRXJFLE9BQU8sRUFBRSxHQUFHLFFBQVEsRUFBRSxTQUFTLEVBQUUsQ0FBQTtJQUNuQyxDQUFDO0NBQ0Y7QUFWRCxzQ0FVQyJ9